const MarketStatusMap = {
    purchase: 'purchase',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    currentPrice: 'current plan',
    currentPriceTrial: 'Need More Credits?',
    select: 'select',
};

export default MarketStatusMap;